import React from 'react'
import styled from 'styled-components'

// Components
import Image from 'components/shared/ImageGatsby'
import { ScrollRevealItem } from 'components/shared/ScrollReveal'
import ButtonDefault from 'components/elements/ButtonDefault'
import ParseContent from 'components/shared/ParseContent'

const StyledButtonDefault = styled(ButtonDefault)`
  & > a {
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.color.text.main};
    color: ${(props) => props.theme.color.text.main};
    padding: 17px 15px;

    &:hover {
      color: ${(props) => props.theme.color.text.main};
    }
  }
`

const StyledImage = styled(Image)`
  max-height: 300px;
`

interface PostsProductsProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Posts
}

function PostsProducts({ fields }: PostsProductsProps) {
  return (
    <section>
      <div className="container py-5">
        <div className="row py-lg-5">
          {fields?.product?.map((edge, index: number) => (
            <ScrollRevealItem
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className="col-lg-4 col-md-6 mb-5"
              sequenceIndex={index}
            >
              <StyledImage
                image={edge?.image}
                alt="Lofthus"
                className="mb-4"
                loading="lazy"
              />
              <div>
                <ParseContent content={edge?.description} />
                <StyledButtonDefault
                  to={edge?.link?.url || ''}
                  className="my-4 text-center"
                >
                  {edge?.link?.title}
                </StyledButtonDefault>
              </div>
            </ScrollRevealItem>
          ))}
        </div>
      </div>
    </section>
  )
}

export default PostsProducts
